// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OVdCS","right":"styles_right__FH3wZ"};